document.addEventListener('click', (e) => {
  const button = e.target.closest('[data-tab]');
  if (!button) return;

  const root = button.closest('[data-tabs]');
  const id = button.dataset.tab;

  root.querySelectorAll('[data-tab]').forEach((btn) => {
    btn.classList.toggle('is-active', btn === button);
    btn.setAttribute('aria-selected', btn === button);
  });

  root.querySelectorAll('[data-tab-panel]').forEach((panel) => {
    panel.classList.toggle('is-active', panel.dataset.tabPanel === id);
  });
});
